import { css, theme } from 'twind/css'
import { XIcon } from '@heroicons/react/solid'
import { useTw } from '../../../../utils/Styles'
import { BotTag } from '../../../../utils/Tags'
import { defaultLogo, MessagePreview, useSenderInfo } from '../../../../utils'
import { ConversationItemFragment } from '../../../../api/Fragments/ConversationItem.generated'

const card_styles = css`
  display: flex;
  width: 350px;
  bottom: 100px;
  padding: 16px;
  position: fixed;
  cursor: pointer;
  max-height: 115px;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(76, 72, 89, 0.25);
  border-radius: 8px;

  > * + * {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }
`

const close_styles = css`
  cursor: pointer;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: ${theme('colors.neutral.300')};
`

const constent_styles = css`
  flex-grow: 1;

  & > :first-child {
    color: #1e1e31;
    font-size: 14px;
    font-weight: 600;
  }

  & > :last-child {
    line-clamp: 3;
    font-size: 14px;
    line-height: 20px;
    color: #4c4859;
    overflow: hidden;
    max-height: 60px;
    box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
`

export function MessagePeek({
  left,
  message,
  onClose,
  onOpen,
}: {
  left?: boolean
  message: ConversationItemFragment
  onOpen: () => void
  onClose: () => void
}) {
  const tw = useTw()
  const sender = useSenderInfo(message)
  return (
    <div
      className={tw(card_styles, left ? `left-[20px]` : `right-[20px]`)}
      onClick={onOpen}
    >
      <img
        src={sender?.logoURL || defaultLogo}
        key={sender?.name}
        alt={`${sender?.name || 'default'} Avatar`}
        className={tw`select-none inline-block border border-transparent border-white h-10 w-10 bg-white object-cover rounded-full`}
      />
      <div className={tw(constent_styles)}>
        <div>
          <p>
            {sender?.name}
            {sender?.bot ? <BotTag /> : null}
          </p>
        </div>
        <div
          className={tw`whitespace-nowrap line-clamp-5`}
          title={
            message.content.messageString
              ? message.content.messageString
              : undefined
          }
        >
          <MessagePreview message={message} />
        </div>
      </div>
      <div
        className={tw(close_styles)}
        onClick={(e) => {
          e.stopPropagation()
          onClose()
        }}
      >
        <XIcon />
      </div>
    </div>
  )
}
